import React, { useState } from "react";
import numeral from "numeral";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCompressArrowsAlt, faExpandArrowsAlt } from "@fortawesome/free-solid-svg-icons";
import { Button } from "aible";
import { useDispatch, useSelector } from "types/store";
import { isEnabled } from "utils/featureFlags";
import { LineInput } from "components/Inputs/LineInput";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { getIsTableauMode } from "containers/App/reducer";
import { handleSelectUseCase } from "containers/ChatGPT/reducer";
import { MAX_ARCS, getDataset, getDefaultSuccess } from "containers/Home/reducer";
import LeakageChartContainer from "containers/Next/Charts/LeakageChart";
import { getInsightCombinationCount, openExploration } from "containers/Next/NextReducer";
import styles from "./style.module.css";
import CompassIcon from "images/SenseIcons/compass-light 1.svg";
import { getIsLoadingChat, getIsLoadingExplore, getIsOpenInsights, getMinimumValueCount, getOutcome } from "containers/Sense/dataset-selectors";
import { updateTileState } from "containers/Sense/reducer";
const SHOW_ARC_CONTROLS = false;
const MiniInsightsPanel = ({ datasetId }) => {
    const dispatch = useDispatch();
    const dataset = useSelector((state) => getDataset(state, datasetId));
    const outcomeSuccess = useSelector((state) => getOutcome(state, datasetId).outcomeSuccess);
    const minimumValueCount = useSelector((state) => getMinimumValueCount(state, datasetId));
    const isOpen = useSelector((state) => getIsOpenInsights(state, datasetId));
    const updateIsOpen = (isOpenInsights) => {
        dispatch(updateTileState(datasetId, { isOpenInsights }));
    };
    const isLoadingExplore = useSelector((state) => getIsLoadingExplore(state, datasetId));
    const updateIsLoadingExplore = (isLoadingExplore) => {
        dispatch(updateTileState(datasetId, { isLoadingExplore }));
    };
    const isLoadingChat = useSelector((state) => getIsLoadingChat(state, datasetId));
    const isTableauMode = useSelector((state) => getIsTableauMode(state));
    const [chordCount, updateChordCount] = useState(MAX_ARCS);
    const [isHideOther, updateIsHideOther] = useState(false);
    const insightCount = dataset?.interaction_scores?.length ?? 0;
    const SORT_CUTOFF = 1;
    const defaultSuccess = useSelector((state) => getDefaultSuccess(state, datasetId));
    const field = dataset?.fields?.[dataset?.outcome ?? ""];
    const outcomeOptions = field?.type !== "number" && field?.data !== undefined
        ? field?.data.map((d) => ({
            value: d,
            label: d.value
        }))
        : undefined;
    const outcomeValue = outcomeSuccess ?? outcomeOptions?.find((o) => o?.value?.value === defaultSuccess) ?? outcomeOptions?.[0];
    const datasetSuccess = outcomeOptions?.find((o) => o?.value?.value === defaultSuccess) && outcomeOptions?.[0];
    const outcome = dataset?.outcome;
    const winrateLabel = outcome + (datasetSuccess?.value?.value ? ": " + datasetSuccess.value.value : "");
    const maxChordCount = chordCount;
    const insightCombinationCount = useSelector((state) => getInsightCombinationCount(state, undefined, datasetId));
    const showExploreButton = isEnabled("aible-optimize") || isEnabled("aible-explore") || Boolean(isTableauMode);
    const showChatAibleButton = isEnabled("chat-aible");
    return (React.createElement("div", { id: "insightsSection_" + dataset?.id, className: isOpen ? styles.openOverview : styles.overview, style: {
            height: isOpen ? "610px" : "190px",
            width: "100%",
            // marginLeft: isOpen || isOpenAIReadiness ? "10px" : "0px",
            // marginRight: "0px",
            position: "relative"
        }, onClick: isOpen !== true ? () => updateIsOpen(!isOpen) : undefined },
        React.createElement("div", { className: styles.overviewItem },
            React.createElement("div", { className: styles.senseTitle },
                React.createElement("div", { className: styles.sTitle, style: isOpen !== true ? { width: "100%" } : {} },
                    React.createElement("span", { className: styles.sIcon },
                        React.createElement("img", { src: CompassIcon, style: { height: "16px", width: "16px" } })),
                    React.createElement("span", null, "Insights"),
                    insightCombinationCount !== undefined && !isNaN(insightCombinationCount) && (React.createElement("div", { className: styles.insightsCountBadge },
                        React.createElement("strong", null, numeral(insightCombinationCount).format("0,0")),
                        React.createElement("span", null, " COMBINATIONS AUTOMATICALLY EVALUATED")))),
                isOpen ? (React.createElement("div", { id: "insightsSectionClose_" + dataset?.id, className: styles.closeButton, onClick: () => updateIsOpen(!isOpen) },
                    React.createElement(Button, { style: { padding: "3px" } },
                        React.createElement("div", { className: styles.selIcon, title: "Close" },
                            React.createElement(FontAwesomeIcon, { icon: faCompressArrowsAlt }))))) : (React.createElement("div", { className: styles.expandIcon },
                    React.createElement("div", { className: styles.selIcon },
                        React.createElement(FontAwesomeIcon, { icon: faExpandArrowsAlt }))))),
            React.createElement("div", { className: styles.insightsContent },
                React.createElement("div", { className: styles.muscleChartWrapper, style: {
                        width: isOpen ? "100%" : undefined
                    } },
                    isOpen === true && SHOW_ARC_CONTROLS ? (React.createElement("div", { className: styles.chordCountSetWrapper },
                        React.createElement("div", null, "TOP"),
                        React.createElement("div", { className: styles.chordCountSetInput },
                            React.createElement(LineInput, { isSenseBox: true, value: maxChordCount, onChange: (val) => {
                                    const numericValue = Number(val);
                                    if (!isNaN(numericValue)) {
                                        updateChordCount(Math.round(numericValue));
                                    }
                                } })),
                        React.createElement("div", null, "FACTORS"),
                        React.createElement("div", { className: styles.chordCountHideOtherWrapper },
                            React.createElement("input", { type: "checkbox", checked: isHideOther, onChange: () => updateIsHideOther(!isHideOther), style: {
                                    marginRight: "5px",
                                    marginTop: "-1px"
                                } }),
                            React.createElement("div", null, "HIDE OTHER")))) : (React.createElement("div", { className: styles.insightsTitle, style: isOpen ? { color: "#4B495B" } : undefined }, "Top Factors")),
                    React.createElement("div", { className: styles.muscleChartInsights, style: {
                            height: isOpen ? "300px" : "140px",
                            overflow: isOpen ? undefined : "hidden",
                            marginTop: isOpen ? "100px" : undefined,
                            marginBottom: isOpen ? "85px" : "0px",
                            fontSize: "12px"
                        } },
                        React.createElement(LeakageChartContainer, { id: "new", datasetId: dataset?.id, isHoverInsights: isOpen, isMedium: true, isSenseTile: true, hideChords: isOpen !== true, maxArcCount: maxChordCount, hideOther: isHideOther }),
                        isOpen !== true && (React.createElement("div", { className: styles.overviewLargeCenterInsight, style: insightCount < 10
                                ? {
                                    top: "55px"
                                }
                                : {
                                    top: "55px"
                                } }, insightCount))),
                    isOpen && (showChatAibleButton || showExploreButton) && (React.createElement("div", { className: styles.exploreButton }, isLoadingExplore === true ? (React.createElement(LoadingIndicator, { style: {
                            margin: "0px",
                            marginTop: "-60px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            position: "absolute"
                        } })) : (React.createElement(React.Fragment, null,
                        showChatAibleButton && (React.createElement(Button, { onClick: () => {
                                dispatch(handleSelectUseCase("CHATAIBLE_ANALYTICS", dataset?.id));
                            }, className: styles.exploreButtonHover, style: {
                                flexGrow: 1,
                                flexBasis: "250px",
                                marginRight: showExploreButton ? "10px" : undefined
                            }, isLoading: isLoadingChat === true }, "Agentic Analytics Chat")),
                        showExploreButton && (React.createElement(Button, { onClick: () => {
                                updateIsLoadingExplore(true);
                                setTimeout(() => dispatch(openExploration(dataset?.id, outcomeValue, undefined, minimumValueCount)).finally(() => updateIsLoadingExplore(false)), 5);
                            }, className: styles.exploreButtonHover, style: { flexGrow: 1, flexBasis: "250px" } }, "Explore Insights")))))))))));
};
export default MiniInsightsPanel;
